import { IConfig } from '../../config';
import { ConnectionState, SSESource, UserStreamMessage } from '../../types';
import { NbLogger } from '../../utils';
import { BaseSSEConnection } from './baseSSEConnection';
import { UserStreamClient } from './userStreamClient';

export class UserStreamConnection extends BaseSSEConnection<UserStreamMessage> {
  // static create(
  //   offlineMode: boolean,
  //   logger: NbLogger,
  //   onConnectionStateChange: (connectionState: ConnectionState, broadcastConnectionState: boolean) => void,
  //   onUserStreamMessage: (data: UserStreamMessage) => void,
  //
  // ) {
  //   return new UserStreamConnection(offlineMode, logger, onConnectionStateChange, onUserStreamMessage);
  // }

  protected source = SSESource.UserStream;

  constructor(
    offlineMode: boolean,
    logger: NbLogger,
    onConnectionStateChange: (connectionState: ConnectionState, broadcastConnectionState: boolean) => void,
    userStreamClient: UserStreamClient,
    config: IConfig,
    private onUserStreamMessage: (data: UserStreamMessage) => void,
  ) {
    super(logger, userStreamClient, offlineMode, onConnectionStateChange, config);
  }

  protected override onMessageReceived(message: UserStreamMessage) {
    this.onUserStreamMessage(message);
  }

  setToken(token: string) {
    this.client.setToken(token);
  }
}
